import app from 'flarum/common/app';

app.initializers.add('cip/graph-integration', () => {
  console.log('Graph Integration extension initialized');
});
